<div class="row">
  <div class="col">
    <h1 class="mt-4 mb-3">About POSH</h1>
    <p>The Polar Observing Site Hub (POSH) is a discovery portal that
    compiles details from multiple observing inventories for over 50,000
    research and monitoring sites, such as: stations, facilities, plots,
    moorings, observatories, platforms, community-based observations,
    and wherever repeat measurements have been made.  For each site,
    POSH displays location, site name, description, organization,
    contact information, associated networks, observed properties, and
    more.  Overall, it is designed to provide a more comprehensive
    perspective on where and how observing takes place across the high
    latitudes.</p>
    <p>POSH is not the original source for this information.  Instead,
    it links to authoritative source catalogs, including:</p>
    <a href="https://arcticobservingviewer.org" target="_blank">
      <img src="https://images.squarespace-cdn.com/content/v1/5273e59ae4b070db6e37803a/be85cc19-f00b-4a60-835d-12cb146be6f1/AOV_Logo_with_observation_sites.png"
	   style="width: 36em"
	   class="d-block mx-auto mb-2" alt="AOV" /></a>
    <a href="https://deims.org" target="_blank">
      <img src="https://deims.org/docs/_images/logo_title_inline_height50.png"
	   class="d-block mx-auto mb-3" alt="DEIMS-SDR" /></a>
    <a href="https://eu-interact.org" target="_blank">
      <img src="https://eu-interact.org/app/uploads/2018/03/INTERACT-logo_high-resolution.png"
           style="width: 14em"
	   class="d-block mx-auto mb-4" alt="INTERACT" /></a>
    <a href="https://sios-svalbard.org" target="_blank">
      <img src="https://sios-svalbard.org/system/files/common/Logo-SIOS-ORIGINAL-rgb-simple_trimmed_small.png"
	   style="width: 11em"
	   class="d-block mx-auto mb-5" alt="SIOS" /></a>
    <p>Because POSH is an aggregator, it does not replace these
    catalogs.  Instead, it relies on them and highlights the need for
    their continued funding.  This approach is similar to how Expedia
    and other travel portals simultaneously combine results from
    multiple providers, and makes it easier for end users to find the
    information they need without searching across numerous disconnected
    resources.  POSH is only as accurate and complete as the source
    catalogs, which should be supported and maintained.</p>
    <p>POSH is currently a prototype.  It is a test case and proof of
    concept for aggregating site metadata from an ecosystem of
    distributed nodes.  Additional funding is being sought to add tens
    of thousands of sites from other inventories.  The end goal is to
    have a sustainable discovery portal that is distributed,
    interoperable, extensive, and integrated.</p>
    <p>POSH was created as a collaboration among the
    <a href="https://arcticobserving.org" target="_blank">Sustaining
    Arctic Observing Networks initiative</a> (SAON), the
    <a href="https://arcticportal.org" target="_blank">Arctic
    Portal</a>, and the <a href="https://www.colorado.edu">University of
    Colorado Boulder</a>, with initial funding from SAON and the
    <a href="https://globalocean.noaa.gov/research/gomo-arctic-research-program"
    target="_blank">NOAA GOMO Arctic Research Program</a>.  It aligns
    with the vision of the SAON
    <a href="https://www.polarobservingassets.org" target="_blank">Polar
    Observing Assets Working Group</a> (POAwg), which has a goal of
    making observing-related metadata more Findable, Accessible,
    Interoperable, and Reusable (the FAIR Principles).</p>
    <p>Looking for more information specifically on polar observing
    systems?  Please see our companion tool, the
    <a href="https://polarobservingregistry.org"
    target="_blank">Registry of Polar Observing Networks</a>
    (RoPON).</p>
    <p><a routerLink="/contact">Contact us</a> for more information, and
    feedback is appreciated.</p>
  </div>
</div>
